// Constants
export const list_users = () => {
  return {
    list_users: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        datatype: {
          predeterminate: ''
        }
      },
      name: {
        type: 'text',
        label: 'Nombres',
        name: 'dusNombre',
        placeholder: '',
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        description: 'nombres',
        prepend: '',
        append: '',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },  
      email: {
        type: 'text',
        label: 'Email',
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      password: {
        type: 'text',
        label: 'Contraseña',
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '123456789',
        }
      },   
      permisos_modulos: {
        type: 'json',
        label: 'Contraseña',
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'json',
          predeterminate: {},
        }
      }, 
      permisos_delete: {
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        description: 'si es visible',
        label: 'Puede eliminar contenido',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      admin: {
        namepath: ['admin_usuarios','afiliacion_pendientes'],
        description: 'si es visible',
        label: 'Permisos de Administrador',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
    }
  }
}
